import { InjectionToken } from '@angular/core';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core';
import { IGmbLocation } from '@boxx/gmb-core';
import { Observable } from 'rxjs';
import { IGmbAnalytics, IGMBReviews, IStoreAnalytics } from '../contracts/IAnalitycs';

export interface IGmbRepository {
  getLocation(): Observable<IHttpBasicResponse<IGmbLocation>>;
  getAnalytics(customFiler: any): Observable<IHttpBasicResponse<IGmbAnalytics>>;
  getGMBReviews(): Observable<IHttpBasicResponse<IGMBReviews>>;
  getStoreAnalytics(customFiler: any): Observable<IHttpBasicResponse<IStoreAnalytics>>;
  getAccumulatedAnalytics(customFiler: any): Observable<IHttpBasicResponse<any>>;
  setAuthCode(
    payload: ISetAuthCodePayload
  ): Observable<JsonApiResponse<IGmbLocation[]>>;
  setSelectedLocation(
    payload: IGmbLocation
  ): Observable<JsonApiResponse<IGmbLocation>>;
  getGMBCategories(query: string): Observable<JsonApiResponse<JsonApiResponse<any>>>;
  createGBP(payload: any): Observable<any>;
  verifyGBP(payload: any): Observable<any>;
  getAuthCode(accessToken: any, idToken: any): Observable<any>;
}
export const GMB_REPOSITORY = new InjectionToken<IGmbRepository>(
  'GMB_REPOSITORY'
);

export interface ISetAuthCodePayload {
  code: string;
  redirect: string;
}
